import { BaseEntityModalPayload } from './base-entity-modal-payload';

export class EntityModalPayload extends BaseEntityModalPayload {
  upe: boolean;
}
